import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import SettingGif from "../../../../assets/images/onboardingImages/setting.gif";
import "./CompletedScreenCM.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
const CompletedScreenCM = () => {
  const [show, setShow] = useState(true);
  const { user } = useSelector((state) => state.user);
  const location = useLocation();
  const [communityName, setCommunityName] = useState(null);
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/member/dashboard", { replace: true });
    setShow(false);
  };

  useEffect(() => {
    if (user) {
      const communityName =
        user?.role === "leader"
          ? user?.leaderCommunity?.name
          : user?.memberCommunities[0]?.community?.name;
      setCommunityName(communityName);
    }
  }, [user]);
  useEffect(() => {
    if (location?.state?.from !== "onboarding") {
      navigate("/member/dashboard", { replace: true });
    } else {
      setShow(true);
    }
  }, []);

  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        centered
        dialogClassName="custom-onboarding-modal cmSide completedScreenCM"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body className="figma-drop-shadow">
          {/* <button
            type="button"
            className="reverseArrow"
            onClick={() =>
              navigate("/member/onboarding/connection", { replace: true })
            }
          >
            <img src={Arrow} alt="" />
          </button> */}
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="" />
          </button>
          <div className="onboardingContentBox">
            <p className="businessName mb25px">{communityName}</p>
            <img className="comletedGif" src={SettingGif} alt="Setting Gif" />
            <p className="completedTitle pt14px">Yay! Setup is complete!</p>
            <p className="completedDesc">
              {`Please make sure you have min. $${user?.memberCommunities?.[0]?.community?.subscription?.[0]?.minimumFunding}`}{" "}
              in your
              <br />
              <strong>Binance Futures Perpetual account</strong>
            </p>

            <BubbleSvgButton
              className="NextBtnInv"
              onClick={handleClose}
              text={"Ok, let's go!"}
              type="button"
              variant="black"
              containerStyling={{
                justifyContent: "center",
              }}
              mainDivStyle={{
                width: "275px",
                height: "55px",
              }}
            />
          </div>
          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            {/* <button className="dot"></button>W */}
            {/* <button className="dot"></button> */}
            <button className="dot active"></button>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CompletedScreenCM;
